import { render, staticRenderFns } from "./report_not_configured_project.vue?vue&type=template&id=26a0815e&"
import script from "./report_not_configured_project.vue?vue&type=script&lang=js&"
export * from "./report_not_configured_project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports